import { useState } from "react";

import type { DotMatrixCommonProps } from "@/components/ui/dotmatrix-core";
import { DotmSquare1 } from "@/components/ui/dotm-square-1";
import { DotmSquare2 } from "@/components/ui/dotm-square-2";
import { DotmSquare3 } from "@/components/ui/dotm-square-3";
import { DotmSquare4 } from "@/components/ui/dotm-square-4";
import { DotmSquare5 } from "@/components/ui/dotm-square-5";
import { DotmSquare6 } from "@/components/ui/dotm-square-6";
import { DotmSquare7 } from "@/components/ui/dotm-square-7";
import { DotmSquare8 } from "@/components/ui/dotm-square-8";
import { DotmSquare9 } from "@/components/ui/dotm-square-9";
import { DotmSquare10 } from "@/components/ui/dotm-square-10";
import { DotmSquare11 } from "@/components/ui/dotm-square-11";
import { DotmSquare12 } from "@/components/ui/dotm-square-12";
import { DotmSquare13 } from "@/components/ui/dotm-square-13";
import { DotmSquare14 } from "@/components/ui/dotm-square-14";
import { DotmSquare15 } from "@/components/ui/dotm-square-15";
import { DotmSquare16 } from "@/components/ui/dotm-square-16";
import { DotmSquare17 } from "@/components/ui/dotm-square-17";
import { DotmSquare18 } from "@/components/ui/dotm-square-18";
import { DotmSquare19 } from "@/components/ui/dotm-square-19";
import { DotmSquare20 } from "@/components/ui/dotm-square-20";
import { DotmCircular2 } from "@/components/ui/dotm-circular-2";
import { DotmCircular3 } from "@/components/ui/dotm-circular-3";
import { DotmCircular4 } from "@/components/ui/dotm-circular-4";
import { DotmCircular5 } from "@/components/ui/dotm-circular-5";
import { DotmCircular6 } from "@/components/ui/dotm-circular-6";
import { DotmCircular7 } from "@/components/ui/dotm-circular-7";
import { DotmCircular10 } from "@/components/ui/dotm-circular-10";
import { DotmCircular11 } from "@/components/ui/dotm-circular-11";
import { DotmCircular12 } from "@/components/ui/dotm-circular-12";
import { DotmCircular14 } from "@/components/ui/dotm-circular-14";
import { DotmCircular15 } from "@/components/ui/dotm-circular-15";
import { DotmCircular17 } from "@/components/ui/dotm-circular-17";
import { DotmCircular18 } from "@/components/ui/dotm-circular-18";
import { DotmCircular19 } from "@/components/ui/dotm-circular-19";
import { DotmCircular20 } from "@/components/ui/dotm-circular-20";
import { DotmTriangle1 } from "@/components/ui/dotm-triangle-1";
import { DotmTriangle2 } from "@/components/ui/dotm-triangle-2";
import { DotmTriangle3 } from "@/components/ui/dotm-triangle-3";
import { DotmTriangle4 } from "@/components/ui/dotm-triangle-4";
import { DotmTriangle5 } from "@/components/ui/dotm-triangle-5";
import { DotmTriangle6 } from "@/components/ui/dotm-triangle-6";
import { DotmTriangle7 } from "@/components/ui/dotm-triangle-7";
import { DotmTriangle8 } from "@/components/ui/dotm-triangle-8";
import { DotmTriangle9 } from "@/components/ui/dotm-triangle-9";
import { DotmTriangle10 } from "@/components/ui/dotm-triangle-10";
import { DotmTriangle11 } from "@/components/ui/dotm-triangle-11";
import { DotmTriangle12 } from "@/components/ui/dotm-triangle-12";
import { DotmTriangle13 } from "@/components/ui/dotm-triangle-13";
import { DotmTriangle14 } from "@/components/ui/dotm-triangle-14";
import { DotmTriangle15 } from "@/components/ui/dotm-triangle-15";
import { DotmTriangle16 } from "@/components/ui/dotm-triangle-16";
import { DotmTriangle17 } from "@/components/ui/dotm-triangle-17";
import { DotmTriangle18 } from "@/components/ui/dotm-triangle-18";
import { DotmTriangle19 } from "@/components/ui/dotm-triangle-19";
import { DotmTriangle20 } from "@/components/ui/dotm-triangle-20";

const SPINNERS = [
  DotmSquare1, DotmSquare2, DotmSquare3, DotmSquare4, DotmSquare5,
  DotmSquare6, DotmSquare7, DotmSquare8, DotmSquare9, DotmSquare10,
  DotmSquare11, DotmSquare12, DotmSquare13, DotmSquare14, DotmSquare15,
  DotmSquare16, DotmSquare17, DotmSquare18, DotmSquare19, DotmSquare20,
  DotmCircular2, DotmCircular3, DotmCircular4, DotmCircular5,
  DotmCircular6, DotmCircular7, DotmCircular10,
  DotmCircular11, DotmCircular12, DotmCircular14, DotmCircular15,
  DotmCircular17, DotmCircular18, DotmCircular19, DotmCircular20,
  DotmTriangle1, DotmTriangle2, DotmTriangle3, DotmTriangle4, DotmTriangle5,
  DotmTriangle6, DotmTriangle7, DotmTriangle8, DotmTriangle9, DotmTriangle10,
  DotmTriangle11, DotmTriangle12, DotmTriangle13, DotmTriangle14, DotmTriangle15,
  DotmTriangle16, DotmTriangle17, DotmTriangle18, DotmTriangle19, DotmTriangle20,
] as const;

function pickRandomSpinner() {
  return SPINNERS[Math.floor(Math.random() * SPINNERS.length)];
}

export function RandomDotmSpinner({ size = 16, dotSize, ...rest }: DotMatrixCommonProps) {
  const [Spinner] = useState(pickRandomSpinner);
  const resolvedDotSize = dotSize ?? Math.max(1, Math.round(size / 6));
  return <Spinner size={size} dotSize={resolvedDotSize} {...rest} />;
}
